import React, {useState} from "react";
import {useStore} from "../../../hooks/useStore";
import {useFetch} from "../../../hooks/useFetch";
import {PacketObjectionTable} from "./packetobjectionTable/PacketObjectionTable";
import {Col, DatePicker, message, Row} from "antd";
import {SelectField} from "../../_defaultComponents/FilterComponents/FilterComponentStyles";
import {ChangeObjectionStatusModal} from "./modals/ChangeObjectionStatusModal";
import locale from "antd/es/date-picker/locale/tr_TR";
import moment from "moment";
import SubCompanyInput from "../../createDeliveryRequest/deliveryRequestForm/pickupInformation/subCompanyInput/SubCompanyInput";

export const ObjectionPage = () => {
    const stores = useStore();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [selectedSubcompany, setSelectedSubcompany] = useState("");
    const [objectionStatus, setObjectionStatus] = useState("all");
    const [visibleChangeStatusModal, setVisibleChangeStatusModal] = useState(false);
    const defaultDateRange = [moment().subtract(30, "days"), moment()];
    const [selectedDateRange, setSelectedDateRange] = useState(defaultDateRange);

    const handleDateRangeChange = dates => {
        if (!dates || dates.length === 0) {
            setSelectedDateRange([]);
            return;
        }

        const [startDate, endDate] = dates;
        const today = moment();
        const ninetyDaysAgo = today.clone().subtract(90, "days");

        if (startDate && endDate) {
            if (endDate.diff(startDate, "days") > 90) {
                message.warning("Tarih aralığı 90 günden fazla olamaz.");
                return;
            }
            if (endDate.isAfter(today)) {
                message.warning("Bitiş tarihi bugünden sonra olamaz.");
                return;
            }
            setSelectedDateRange([startDate, endDate]);
        } else if (startDate) {
            if (startDate.isBefore(ninetyDaysAgo)) {
                message.warning("Başlangıç tarihi bugünden 90 günden daha önce olamaz.");
                return;
            }
            setSelectedDateRange([startDate, null]);
        } else if (endDate) {
            if (endDate.isAfter(today)) {
                message.warning("Bitiş tarihi bugünden sonra olamaz.");
                return;
            }
            const calculatedStartDate = moment.max(
                endDate.clone().subtract(90, "days"),
                ninetyDaysAgo
            );
            setSelectedDateRange([calculatedStartDate, endDate]);
        }
    };

    const [objectionLoading, objectionData, _, __, refetch] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.companyStore.getObjectionsCreditLog.bind(null, {
            limit,
            page,
            subcompanyId:
                selectedSubcompany && selectedSubcompany !== "all" ? selectedSubcompany : undefined,
            status: objectionStatus === "all" ? undefined : objectionStatus,
            startDate: selectedDateRange[0]
                ? moment(selectedDateRange[0]).format("YYYY-MM-DD")
                : undefined,
            endDate: selectedDateRange[1]
                ? moment(selectedDateRange[1]).format("YYYY-MM-DD")
                : undefined
        }),
        showLoading: true,
        dependencies: [limit, page, selectedSubcompany, objectionStatus, selectedDateRange]
    });

    return (
        <div>
            <div style={styles.header}>
                <span>Paket İtirazları</span>
            </div>
            <div>
                <Row style={styles.filters}>
                    <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                        <SubCompanyInput
                            onChange={value => {
                                setSelectedSubcompany(value);
                            }}
                            initialCall={true}
                            allowClear={true}
                            disabled={false}
                            showAllOption={true}
                            value={selectedSubcompany}
                        />
                    </Col>
                    <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                        <h5>İtiraz Durumu</h5>
                        <SelectField
                            value={objectionStatus}
                            onChange={value => {
                                setObjectionStatus(value);
                            }}
                        >
                            <SelectField.Option value="all">Tümü</SelectField.Option>
                            <SelectField.Option value="pending">Bekleyen</SelectField.Option>
                            <SelectField.Option value="approved">Onaylanan</SelectField.Option>
                            <SelectField.Option value="rejected">Reddedilen</SelectField.Option>
                        </SelectField>
                    </Col>
                    <Col xs={80} sm={40} md={24} lg={16} xl={12}>
                        <h5>Tarih</h5>
                        <DatePicker.RangePicker
                            placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
                            onChange={handleDateRangeChange}
                            value={selectedDateRange}
                            locale={locale}
                            disabledDate={current => {
                                const today = moment().endOf("day");
                                return current && current > today;
                            }}
                        />
                    </Col>
                </Row>
            </div>
            <div>
                <PacketObjectionTable
                    objectionData={objectionData}
                    pageState={[page, setPage]}
                    handleChangeStatusForObjection={[
                        visibleChangeStatusModal,
                        modalData => setVisibleChangeStatusModal(modalData)
                    ]}
                />
            </div>
            <ChangeObjectionStatusModal
                visibility={visibleChangeStatusModal.visible}
                objectionId={visibleChangeStatusModal.objectionId}
                objection={visibleChangeStatusModal.objection}
                onCancel={() => setVisibleChangeStatusModal({visible: false, objectionId: null})}
                refetch={refetch}
            />
        </div>
    );
};

const styles = {
    header: {
        fontSize: 20,
        fontWeight: "bold",
        width: "100%",
        marginBottom: 10
    },
    filters: {
        display: "flex",
        gap: 20,
        marginBottom: 20
    }
};
